<template>
  <div class="PacientesForm">
    <DialogEscuelaSeleccionar
      :vista="'PacientesForm'"
      @msg="_notify"
      @escuela="_doEscuela"
      v-bind:showDialogEscuelaSeleccionar="showDialogEscuelaSeleccionar"
    />
    <Loading v-if="cargando" />
    <md-card class="mb24">
      <md-card-header>
        Estas trabajando con la escuela {{escuela_nombre}}.<br>
        <md-button
          class="md-accent md-raised md-dense"
          @click="showDialogEscuelaSeleccionar=true"
        >Cambiar escuela</md-button>
      </md-card-header>
      <md-card-header>
        <div class="md-title">{{paciente.id ? 'Editar' : 'Registrar'}} paciente</div>
      </md-card-header>
      <md-card-content>
        <div class="md-subheading">Información general</div>
        <div class="md-layout md-gutter">
          <div class="md-layout-item md-xsmall-size-100 md-size-33">
            <md-field :class="errores.nombre_pac">
              <label>Nombre(s)</label>
              <md-input
                v-model="paciente.nombre_pac"
                required
              />
            </md-field>
          </div>
          <div class="md-layout-item md-xsmall-size-100 md-size-33">
            <md-field :class="errores.ape_pat_pac">
              <label>Apellido Paterno</label>
              <md-input
                v-model="paciente.ape_pat_pac"
                required
              />
            </md-field>
          </div>
          <div class="md-layout-item md-xsmall-size-100 md-size-33">
            <md-field :class="errores.ape_mat_pac">
              <label>Apellido Materno</label>
              <md-input
                v-model="paciente.ape_mat_pac"
                required
              />
            </md-field>
          </div>
          <div class="md-layout-item md-xsmall-size-100 md-small-size-33 md-size-25">
            <md-field :class="errores.sexo_pac">
              <label>Sexo</label>
              <md-select
                v-model="paciente.sexo_pac"
                md-dense
                @md-selected="_doPacienteEdad(true)"
              >
                <md-option value="femenino">Femenino</md-option>
                <md-option value="masculino">Masculino</md-option>
                <md-option value="prefiero no decirlo">Prefiero no decirlo</md-option>
              </md-select>
            </md-field>
          </div>
          <div class="md-layout-item md-xsmall-size-100 md-small-size-66 md-size-50">
            <div class="md-layout md-gutter">
              <div class="md-layout-item md-xsmall-size-33 md-size-33">
                <md-field :class="errores.fecha_nac_pac">
                  <label>Día</label>
                  <md-select
                    v-model="dia"
                    md-dense
                    @md-selected="_doPacienteEdad(true)"
                  >
                    <md-option
                      v-for="i in 31"
                      :key="i"
                      :value="i"
                    >
                      {{i}}
                    </md-option>
                  </md-select>
                  <span class="md-helper-text">Fecha de nacimiento</span>
                </md-field>
              </div>
              <div class="md-layout-item md-xsmall-size-33 md-size-33">
                <md-field :class="errores.fecha_nac_pac">
                  <label>Mes</label>
                  <md-select
                    v-model="mes"
                    md-dense
                    @md-selected="_doPacienteEdad(true)"
                  >
                    <md-option
                      v-for="mes in meses"
                      :key="mes.numero"
                      :value="mes.numero"
                    >{{mes.nombre}}</md-option>
                  </md-select>
                  <span class="md-helper-text">Fecha de nacimiento</span>
                </md-field>
              </div>
              <div class="md-layout-item md-xsmall-size-33 md-size-33">
                <md-field :class="errores.fecha_nac_pac">
                  <label>Año</label>
                  <md-select
                    v-model="anio"
                    md-dense
                    @md-selected="_doPacienteEdad(true)"
                  >
                    <md-option :value="anioActual">{{anioActual}}</md-option>
                    <md-option
                      v-for="i in 14"
                      :key="i"
                      :value="anioActual -i"
                    >{{anioActual - i}}</md-option>
                  </md-select>
                  <span class="md-helper-text">Fecha de nacimiento</span>
                </md-field>
              </div>
            </div>
          </div>
          <!--div class="md-layout-item md-xsmall-size-100 md-size-33"><md-field :class="errores.edad_pac"><label>Edad</label><md-input type="number" v-model="paciente.edad_pac" required /></md-field></div-->
          <div class="md-layout-item md-xsmall-size-100 md-small-size-50 md-size-25">
            <md-field :class="errores.lugar_nac_pac">
              <label>Lugar de Nacimiento</label>
              <md-input v-model="paciente.lugar_nac_pac" />
            </md-field>
          </div>
          <div class="md-layout-item md-xsmall-size-100 md-small-size-50 md-size-25">
            <md-field :class="errores.religion_pac">
              <label>Religión</label>
              <md-input v-model="paciente.religion_pac" />
            </md-field>
          </div>
          <div class="md-layout-item md-xsmall-size-100 md-small-size-50 md-size-25">
            <md-field
              :class="errores.tel_pac"
              :md-counter="false"
            >
              <label>Teléfono</label>
              <md-input
                v-mask="'### ### ####'"
                v-model="paciente.tel_pac"
                maxlength="12"
              />
            </md-field>
          </div>
        </div>
        <div class="md-subheading mt24">Domicilio</div>
        <div class="md-layout md-gutter">
          <div class="md-layout-item md-xsmall-size-100 md-size-50">
            <md-field :class="errores.id_edo_pac">
              <label for="">Estado</label>
              <md-select
                md-dense
                v-model="paciente.id_edo_pac"
                @md-selected="_filterMpios"
              >
                <md-option
                  v-for="item in this.$estados"
                  :key="item.id_edo"
                  :value="item.id_edo"
                >
                  {{item.nombre_edo}}
                </md-option>
              </md-select>
            </md-field>
          </div>
          <div class="md-layout-item md-xsmall-size-100 md-size-50">
            <md-field :class="errores.id_mpio_pac">
              <label for="">Municipio</label>
              <md-select
                v-model="paciente.id_mpio_pac"
                md-dense
                required
              >
                <md-option
                  v-for="item in municipios"
                  :key="item.id_mpio"
                  :value="item.id_mpio"
                >
                  {{item.nombre_mpio}}
                </md-option>
              </md-select>
            </md-field>
          </div>
          <div class="md-layout-item md-xsmall-size-100 md-small-size-70 md-size-35">
            <md-field :class="errores.calle_pac">
              <label>Calle</label>
              <md-input
                v-model="paciente.calle_pac"
                required
              />
            </md-field>
          </div>
          <div class="md-layout-item md-xsmall-size-100 md-small-size-30 md-size-15">
            <md-field :class="errores.num_ext_pac">
              <label>No. Exterior</label>
              <md-input
                v-model="paciente.num_ext_pac"
                required
              />
            </md-field>
          </div>
          <div class="md-layout-item md-xsmall-size-100 md-small-size-70 md-size-35">
            <md-field :class="errores.colonia_pac">
              <label>Colonia</label>
              <md-input v-model="paciente.colonia_pac" />
            </md-field>
          </div>
          <div class="md-layout-item md-xsmall-size-100 md-small-size-30 md-size-15">
            <md-field :class="errores.cp_pac">
              <label>C.P.</label>
              <md-input v-model="paciente.cp_pac" />
            </md-field>
          </div>
        </div>
        <div class="md-subheading mt24">Peso y talla</div>
        <div class="md-layout md-gutter">
          <div class="md-layout-item md-xsmall-size-100 md-small-size-33 md-medium-size-25 md-size-15">
            <md-field :class="errores.peso_pac">
              <label>Peso</label>
              <md-input
                v-model="paciente.peso_pac"
                @blur="_calcularIMC"
                required
              />

            </md-field>
          </div>
          <div class="md-layout-item md-xsmall-size-100 md-small-size-33 md-medium-size-25 md-size-15">
            <md-field :class="errores.talla_pac">
              <label>Talla</label>
              <md-input
                v-model="paciente.talla_pac"
                max="2"
                @blur="_calcularIMC"
                type="number"
                step=".01"
                min="0"
                required
              />
              <span class="md-helper-text">Unidad en metros</span>
            </md-field>
          </div>
          <div class="md-layout-item md-xsmall-size-100 md-small-size-33 md-medium-size-25 md-size-15">
            <md-field :class="errores.imc_pac">
              <label>IMC</label>
              <md-input
                v-model="paciente.imc_pac"
                disabled
                required
              />
            </md-field>
          </div>
          <div class="md-layout-item md-xsmall-size-100 md-small-size-33 md-size-25">
            <md-field :class="errores.edo_nut_pac">
              <label>Estado nutricional</label>
              <md-input
                v-model="paciente.edo_nut_pac"
                disabled
                required
              />
            </md-field>
          </div>
        </div>
        <div class="md-subheading mt24">Derechohabiencia</div>
        <div class="md-layout md-gutter">
          <div class="md-layout-item md-xsmall-size-100 md-small-size-33 md-medium-size-25 md-size-20">
            <md-field :class="errores.cartilla_pac">
              <label>¿Presentó cartilla?</label>
              <md-select
                v-model="paciente.cartilla_pac"
                md-dense
                required
              >
                <md-option value="si">Si</md-option>
                <md-option value="no">No</md-option>
              </md-select>
            </md-field>
          </div>
          <div class="md-layout-item md-xsmall-size-100 md-small-size-33 md-medium-size-25 md-size-20">
            <md-field :class="errores.afiliacion_pac">
              <label>Afiliación</label>
              <md-select
                v-model="paciente.afiliacion_pac"
                md-dense
              >
                <md-option value="imss">IMSS</md-option>
                <md-option value="issste">ISSSTE</md-option>
                <md-option value="pensiones">Pensiones</md-option>
                <md-option value="sedena">SEDENA</md-option>
                <md-option value="seguro popular">Seguro Popular</md-option>
                <md-option value="ninguno">Ninguno</md-option>
                <md-option value="otro">Otro</md-option>
              </md-select>
            </md-field>
          </div>
          <div
            class="md-layout-item md-xsmall-size-100 md-small-size-33 md-size-25"
            v-if="paciente.afiliacion_pac === 'otro'"
          >
            <md-field :class="errores.afiliacion_otro_pac">
              <label for="">Especifique afiliación</label>
              <md-input v-model="paciente.afiliacion_otro_pac" />
            </md-field>
          </div>
        </div>
      </md-card-content>
      <md-card-actions>
        <md-button @click="showDialogConfirmCancelar=true">Cancelar</md-button>
        <md-button
          class="md-primary md-raised"
          @click="_presave()"
        >{{paciente.id ? 'Actualizar' : 'Guardar'}}</md-button>
      </md-card-actions>
    </md-card>
    <md-dialog-confirm
      :md-active.sync="showDialogConfirmCancelar"
      md-title="¿Desea salir del tamizaje?"
      md-content="Una vez que haya salido, no podrá recuperar la información capturada."
      md-confirm-text="Si, salir"
      md-cancel-text="Cancelar"
      @md-cancel="showDialogConfirmCancelar=false"
      @md-confirm="$router.push('/pacientes')"
    />
  </div>
</template>

<script>
import Loading from "@/components/Loading";
import DialogEscuelaSeleccionar from "@/components/dialogs/DialogEscuelaSeleccionar";
DialogEscuelaSeleccionar;
export default {
  name: "PacientesForm",
  components: { DialogEscuelaSeleccionar, Loading },
  methods: {
    _notify(a) {
      this.escuela_nombre = this.$session.get("escuela_nombre");
      this.$emit("msg", a);
    },
    _doEscuela(a) {
      this.showDialogEscuelaSeleccionar = false;
      this.$emit("escuela", Date.now());
    },
    _filterMpios(a) {
      this.municipios = this.$municipios["a" + a];
    },
    _falloResponse(err) {
      this.cargando = false;
      if (err.status === 401) {
        this.$router.push("/login");
      } else {
        this.$emit("msg", this.$no_internet);
      }
    },
    _obtenerPaciente() {
      let idPac = this.$route.params.idPac;
      let ii = this.pacientes.findIndex(function(b) {
        return b.id === idPac;
      });
      if (ii >= 0) {
        this.indexPaciente = ii;
        this.paciente.id = this.pacientes[ii].id;
        this.paciente.id_pac = this.pacientes[ii].id_pac;
        this.paciente.nombre_pac = this.pacientes[ii].nombre_pac;
        this.paciente.ape_pat_pac = this.pacientes[ii].ape_pat_pac;
        this.paciente.ape_mat_pac = this.pacientes[ii].ape_mat_pac;
        this.paciente.fecha_nac_pac = this.pacientes[ii].fecha_nac_pac;
        this.paciente.edad_pac = this.pacientes[ii].edad_pac;
        this.paciente.lugar_nac_pac = this.pacientes[ii].lugar_nac_pac;
        this.paciente.sexo_pac = this.pacientes[ii].sexo_pac;
        this.paciente.calle_pac = this.pacientes[ii].calle_pac;
        this.paciente.num_ext_pac = this.pacientes[ii].num_ext_pac;
        this.paciente.colonia_pac = this.pacientes[ii].colonia_pac;
        this.paciente.cp_pac = this.pacientes[ii].cp_pac;
        this.paciente.id_edo_pac = this.pacientes[ii].id_edo_pac;
        this.paciente.id_mpio_pac = this.pacientes[ii].id_mpio_pac;
        this.paciente.religion_pac = this.pacientes[ii].religion_pac;
        this.paciente.tel_pac = this.pacientes[ii].tel_pac;
        this.paciente.cartilla_pac = this.pacientes[ii].cartilla_pac;
        this.paciente.afiliacion_pac = this.pacientes[ii].afiliacion_pac;
        this.paciente.afiliacion_otro_pac = this.pacientes[
          ii
        ].afiliacion_otro_pac;
        this.paciente.peso_pac = this.pacientes[ii].peso_pac;
        this.paciente.talla_pac = this.pacientes[ii].talla_pac;
        this.paciente.imc_pac = this.pacientes[ii].imc_pac;
        this.paciente.edo_nut_pac = this.pacientes[ii].edo_nut_pac;
      } else {
        this.$emit("msg", "Paciente no encontrado. Inténtelo de nuevo.");
        this.$router.push("/pacientes");
      }
    },
    _validar() {
      this.errores.nombre_pac = this.$mdError(this.paciente.nombre_pac);
      this.errores.ape_pat_pac = this.$mdError(this.paciente.ape_pat_pac);
      this.errores.ape_mat_pac = this.$mdError(this.paciente.ape_mat_pac);
      this.errores.fecha_nac_pac = this.$mdError(this.paciente.fecha_nac_pac);
      this.errores.sexo_pac = this.$mdError(this.paciente.sexo_pac);
      this.errores.calle_pac = this.$mdError(this.paciente.calle_pac);
      this.errores.num_ext_pac = this.$mdError(this.paciente.num_ext_pac);
      this.errores.id_edo_pac = this.$mdError(this.paciente.id_edo_pac);
      this.errores.id_mpio_pac = this.$mdError(this.paciente.id_mpio_pac);
      if (this.paciente.cartilla_pac != "no") {
        this.errores.afiliacion_pac = this.$mdError(
          this.paciente.afiliacion_pac
        );
      } else {
        this.errores.afiliacion_pac = null;
      }
      this.errores.peso_pac = this.$mdError(this.paciente.peso_pac);
      this.errores.talla_pac = this.$mdError(this.paciente.talla_pac);
      this.errores.imc_pac = this.$mdError(this.paciente.imc_pac);
      this.errores.edo_nut_pac = this.$mdError(this.paciente.edo_nut_pac);
      this.errores.tel_pac = this.$mdError(this.paciente.tel_pac);
      return this.$validate(this.errores);
    },
    _presave() {
      this.paciente.fecha_nac_pac =
        this.anio +
        "-" +
        this.mes +
        "-" +
        (this.dia < 10 ? "0" + this.dia : this.dia);
      let f = this.$moment(this.paciente.fecha_nac_pac).format("YYYY-MM-DD");
      if (this._validar() && f != "Invalid date") {
        if (this.$session.has("escuela")) {
          this.paciente.id ? this._actualizar() : this._guardar();
        }
      } else {
        if (f === "Invalid date") {
          this.errores.fecha_nac_pac = "md-invalid";
        }
        this.$emit("msg", this.$llene_campos);
      }
    },
    _guardar() {
      this.cargando = true;
      let idTemporal = "c." + this.$moment();
      this.pacientes.push({
        id: idTemporal,
        id_pac: idTemporal,
        nombre_pac: this.paciente.nombre_pac,
        ape_pat_pac: this.paciente.ape_pat_pac,
        ape_mat_pac: this.paciente.ape_mat_pac,
        fecha_nac_pac: this.paciente.fecha_nac_pac,
        edad_pac: this.paciente.edad_pac,
        lugar_nac_pac: this.paciente.lugar_nac_pac,
        sexo_pac: this.paciente.sexo_pac,
        calle_pac: this.paciente.calle_pac,
        num_ext_pac: this.paciente.num_ext_pac,
        colonia_pac: this.paciente.colonia_pac,
        cp_pac: this.paciente.cp_pac,
        id_edo_pac: this.paciente.id_edo_pac,
        id_mpio_pac: this.paciente.id_mpio_pac,
        religion_pac: this.paciente.religion_pac,
        tel_pac: this.paciente.tel_pac,
        cartilla_pac: this.paciente.cartilla_pac,
        afiliacion_pac: this.paciente.afiliacion_pac,
        afiliacion_otro_pac: this.paciente.afiliacion_otro_pac,
        peso_pac: this.paciente.peso_pac,
        talla_pac: this.paciente.talla_pac,
        imc_pac: this.paciente.imc_pac,
        edo_nut_pac: this.paciente.edo_nut_pac,
        id_esc_pac: this.$session.get("escuela"),
        nombre_esc: this.$session.get("nombre_escuela")
      });
      this.$router.push("/tamizaje/" + idTemporal);
      this.$emit("msg", "Paciente guardado");
      this.cargando = false;
    },
    _actualizar() {
      this.cargando = true;
      let i = this.indexPaciente;
      this.pacientes[i].nombre_pac = this.paciente.nombre_pac;
      this.pacientes[i].ape_pat_pac = this.paciente.ape_pat_pac;
      this.pacientes[i].ape_mat_pac = this.paciente.ape_mat_pac;
      this.pacientes[i].fecha_nac_pac = this.paciente.fecha_nac_pac;
      this.pacientes[i].edad_pac = this.paciente.edad_pac;
      this.pacientes[i].lugar_nac_pac = this.paciente.lugar_nac_pac;
      this.pacientes[i].sexo_pac = this.paciente.sexo_pac;
      this.pacientes[i].calle_pac = this.paciente.calle_pac;
      this.pacientes[i].num_ext_pac = this.paciente.num_ext_pac;
      this.pacientes[i].colonia_pac = this.paciente.colonia_pac;
      this.pacientes[i].cp_pac = this.paciente.cp_pac;
      this.pacientes[i].id_edo_pac = this.paciente.id_edo_pac;
      this.pacientes[i].id_mpio_pac = this.paciente.id_mpio_pac;
      this.pacientes[i].religion_pac = this.paciente.religion_pac;
      this.pacientes[i].tel_pac = this.paciente.tel_pac;
      this.pacientes[i].cartilla_pac = this.paciente.cartilla_pac;
      this.pacientes[i].afiliacion_otro_pac = this.paciente.afiliacion_otro_pac;
      this.pacientes[i].afiliacion_pac = this.paciente.afiliacion_pac;
      this.pacientes[i].peso_pac = this.paciente.peso_pac;
      this.pacientes[i].talla_pac = this.paciente.talla_pac;
      this.pacientes[i].imc_pac = this.paciente.imc_pac;
      this.pacientes[i].edo_nut_pac = this.paciente.edo_nut_pac;
      this.cargando = false;
      this.$emit("msg", "Paciente actualizado");
      this.$router.push("/pacientes");
    },
    _doPacienteEdad(mustCallEdoNut = false) {
      this.paciente.fecha_nac_pac =
        this.anio +
        "-" +
        this.mes +
        "-" +
        (this.dia < 10 ? "0" + this.dia : this.dia);
      if (mustCallEdoNut) {
        this._calcularIMC();
      }
    },
    _calcularIMC() {
      //peso (kg) / altura (m)2
      console.log("calcular imc");
      let peso = parseFloat(this.paciente.peso_pac);
      let talla = parseFloat(this.paciente.talla_pac);
      if (peso > 0 && talla > 0) {
        this.paciente.imc_pac = parseFloat(peso / (talla * talla)).toFixed(2);
        this._calcularEdoNutricional();
      }
    },
    _calcularEdoNutricional() {
      this._doPacienteEdad(false);
      let imc = parseFloat(this.paciente.imc_pac);
      let sexo = this.paciente.sexo_pac;
      let meses = this.$moment().diff(this.paciente.fecha_nac_pac, "months");
      let anios = ~~(meses / 12);
      let mesesRestantes = meses - anios * 12;
      let edadMeses = `${anios}:${mesesRestantes >= 6 ? 6 : 0}`;
      let edadMeses2 = `${anios}.${mesesRestantes >= 6 ? 6 : 0}`;
      if (parseFloat(edadMeses2) < 5.6) {
        edadMeses = "5:1";
      } else if (parseFloat(edadMeses2) >= 8.6) {
        edadMeses = "8:6";
      }
      if (sexo === "prefiero no decirlo") {
        sexo = "masculino";
      }
      let edoNut = this.estadoNutricional[edadMeses][sexo];
      imc = parseFloat(imc);
      console.dir(edoNut);
      if (edoNut[0] >= imc) {
        this.paciente.edo_nut_pac = "Desnutrición";
      } else if (edoNut[1] <= imc && edoNut[2] >= imc) {
        this.paciente.edo_nut_pac = "Bajo Peso";
      } else if (edoNut[2] <= imc && edoNut[3] >= imc) {
        this.paciente.edo_nut_pac = "Normal";
      } else if (edoNut[3] <= imc && edoNut[4] >= imc) {
        this.paciente.edo_nut_pac = "Sobrepeso";
      } else if (edoNut[4] <= imc) {
        this.paciente.edo_nut_pac = "Obesidad";
      }
    },
    _checkRoute() {
      if (this.$route.params.idPac) {
        this._obtenerPaciente();
      } else {
        this._limpiarCampos();
        this.paciente.id_edo_pac = "8";
        this._filterMpios("8");
      }
    },
    _limpiarCampos() {
      this.paciente.id = null;
      this.errores.id = null;
      this.paciente.id_pac = null;
      this.errores.id_pac = null;
      this.paciente.nombre_pac = null;
      this.errores.nombre_pac = null;
      this.paciente.ape_pat_pac = null;
      this.errores.ape_pat_pac = null;
      this.paciente.ape_mat_pac = null;
      this.errores.ape_mat_pac = null;
      this.paciente.fecha_nac_pac = null;
      this.errores.fecha_nac_pac = null;
      this.paciente.edad_pac = null;
      this.errores.edad_pac = null;
      this.paciente.lugar_nac_pac = null;
      this.errores.lugar_nac_pac = null;
      this.paciente.sexo_pac = null;
      this.errores.sexo_pac = null;
      this.paciente.calle_pac = null;
      this.errores.calle_pac = null;
      this.paciente.num_ext_pac = null;
      this.errores.num_ext_pac = null;
      this.paciente.colonia_pac = null;
      this.errores.colonia_pac = null;
      this.paciente.cp_pac = null;
      this.errores.cp_pac = null;
      this.paciente.id_edo_pac = null;
      this.errores.id_edo_pac = null;
      this.paciente.id_mpio_pac = null;
      this.errores.id_mpio_pac = null;
      this.paciente.religion_pac = null;
      this.errores.religion_pac = null;
      this.paciente.tel_pac = null;
      this.errores.tel_pac = null;
      this.paciente.cartilla_pac = "no";
      this.errores.cartilla_pac = null;
      this.paciente.afiliacion_otro_pac = null;
      this.errores.afiliacion_otro_pac = null;
      this.paciente.afiliacion_pac = null;
      this.errores.afiliacion_pac = null;
      this.paciente.peso_pac = null;
      this.errores.peso_pac = null;
      this.paciente.talla_pac = null;
      this.errores.talla_pac = null;
      this.paciente.imc_pac = null;
      this.errores.imc_pac = null;
      this.paciente.edo_nut_pac = null;
      this.errores.edo_nut_pac = null;
      this.paciente.id_esc_pac = null;
      this.errores.id_esc_pac = null;
    }
  },
  data() {
    return {
      showDialogConfirmCancelar: false,
      showDialogEscuelaSeleccionar: false,
      cargando: false,
      cartilla: false,
      indexPaciente: null,
      anio: null,
      mes: null,
      dia: null,
      paciente: {
        id: null,
        id_pac: null,
        nombre_pac: null,
        ape_pat_pac: null,
        ape_mat_pac: null,
        fecha_nac_pac: null,
        edad_pac: null,
        lugar_nac_pac: null,
        sexo_pac: null,
        calle_pac: null,
        num_ext_pac: null,
        colonia_pac: null,
        cp_pac: null,
        id_edo_pac: null,
        id_mpio_pac: null,
        religion_pac: null,
        tel_pac: null,
        cartilla_pac: null,
        afiliacion_pac: null,
        afiliacion_otro_pac: null,
        peso_pac: 20,
        talla_pac: 1.1,
        imc_pac: null,
        edo_nut_pac: null,
        id_esc_pac: null
      },
      errores: {
        nombre_pac: null,
        ape_pat_pac: null,
        ape_mat_pac: null,
        fecha_nac_pac: null,
        edad_pac: null,
        lugar_nac_pac: null,
        sexo_pac: null,
        calle_pac: null,
        num_ext_pac: null,
        colonia_pac: null,
        cp_pac: null,
        id_edo_pac: null,
        id_mpio_pac: null,
        religion_pac: null,
        tel_pac: null,
        cartilla_pac: null,
        afiliacion_pac: null,
        afiliacion_otro_pac: null,
        peso_pac: null,
        talla_pac: null,
        imc_pac: null,
        edo_nut_pac: null,
        id_esc_pac: null
      },
      municipios: [],
      pacientes: [],
      estadoNutricional: {
        "5:1": {
          femenino: [11.7, 11.8, 12.7, 16.9, 19],
          masculino: [12, 12.1, 13, 16.7, 18.4]
        },
        "5:6": {
          femenino: [11.6, 11.7, 12.7, 16.9, 19.1],
          masculino: [12, 12.1, 13, 16.8, 18.5]
        },
        "6:0": {
          femenino: [11.6, 11.7, 12.7, 16.9, 19],
          masculino: [12, 12.1, 13, 16.9, 18.6]
        },
        "6:6": {
          femenino: [11.6, 11.7, 12.7, 17.1, 19.6],
          masculino: [12.1, 12.2, 13.1, 17, 18.8]
        },
        "7:0": {
          femenino: [11.7, 11.8, 12.7, 17.3, 19.9],
          masculino: [12.2, 12.3, 13.1, 17, 19.1]
        },
        "7:6": {
          femenino: [11.7, 11.8, 12.8, 17.5, 20.2],
          masculino: [12.2, 12.3, 13.2, 17.3, 19.4]
        },
        "8:0": {
          femenino: [11.8, 11.9, 12.9, 17.7, 20.7],
          masculino: [12.3, 12.4, 13.3, 17.5, 19.8]
        },
        "8:6": {
          femenino: [11.9, 12.0, 13.0, 18.0, 21.1],
          masculino: [12.4, 12.5, 13.4, 17.8, 20.2]
        }
      },
      escuela_nombre: "",
      meses: [
        { numero: "01", nombre: "Enero" },
        { numero: "02", nombre: "Febrero" },
        { numero: "03", nombre: "Marzo" },
        { numero: "04", nombre: "Abril" },
        { numero: "05", nombre: "Mayo" },
        { numero: "06", nombre: "Junio" },
        { numero: "07", nombre: "Julio" },
        { numero: "08", nombre: "Agosto" },
        { numero: "09", nombre: "Septiembre" },
        { numero: "10", nombre: "Octubre" },
        { numero: "11", nombre: "Noviembre" },
        { numero: "12", nombre: "Diciembre" }
      ],
      anioActual: new Date().getFullYear()
    };
  },
  watch: {
    $route(to, from) {
      this._checkRoute();
    }
  },
  beforeDestroy() {
    localStorage.setItem("pacientes", JSON.stringify(this.pacientes));
  },
  created() {
    if (localStorage.getItem("pacientes")) {
      this.pacientes = JSON.parse(localStorage.getItem("pacientes"));
    }
    this._checkRoute();
    this.escuela_nombre = this.$session.get("escuela_nombre");
  },
  beforeCreate() {
    if (!this.$session.exists() && !this.$session.get("tipo")) {
      this.$emit("visible", false);
      this.$router.push("/login");
    } else {
      this.$emit("visible", true);
      this.$emit("classes", "container");
    }
  }
};
</script>